var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluedownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C3.90434 5 3.81465 4.9841 3.73094 4.95229C3.64723 4.92048 3.56951 4.86641 3.49776 4.79008L0.197309 1.27863C0.0657698 1.13868 0 0.96056 0 0.744275C0 0.52799 0.0657698 0.349873 0.197309 0.209924C0.328849 0.0699745 0.496263 0 0.699552 0C0.90284 0 1.07025 0.0699745 1.20179 0.209924L4 3.18702L6.79821 0.209924C6.92975 0.0699745 7.09716 0 7.30045 0C7.50374 0 7.67115 0.0699745 7.80269 0.209924C7.93423 0.349873 8 0.52799 8 0.744275C8 0.96056 7.93423 1.13868 7.80269 1.27863L4.50224 4.79008C4.43049 4.86641 4.35277 4.92048 4.26906 4.95229C4.18535 4.9841 4.09567 5 4 5Z",
    fill: "#036BAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluedownarrow);
export default __webpack_public_path__ + "static/media/bluedownarrow.2d2174e86b8af4dcb9f775627a739384.svg";
export { ForwardRef as ReactComponent };